
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/graphic-design",
      function () {
        return require("private-next-pages/us/graphic-design.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/graphic-design"])
      });
    }
  